<h2 mat-dialog-title>Production Job Audits</h2>
<mat-dialog-content style="min-height:350px; min-width: 550px; margin-bottom: 12px;" class="custom-scroll">
    <div class="audit-container">
        <div *ngIf="!isLoading && audits.length >= 1" style="width: 100%;">
            <table class="audit-table">
                <thead>
                  <tr>
                    <th></th>
                    <th>Event</th>
                    <th>Shared Id</th>
                    <th>Email</th>
                    <th>IP Address</th>
                    <th>Date (UTC)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let audit of audits">
                    <td>
                        <i [matTooltip]="audit.browser" class="icon" [ngClass]="audit.browserIcon" style="margin-right: 8px;"></i>
                        <i [matTooltip]="audit.operatingSystem" class="icon" [ngClass]="audit.operatingSystemIcon"></i>
                    </td>
                    <td [matTooltip]="getTooltipContent(audit)">{{ audit.description || 'Unknown Action' }}</td>
                    <td>{{ audit.sharedExportId || 'N/A' }}</td>
                    <td>{{ audit.email || 'N/A' }}</td>
                    <td>{{ audit.ipv4 || 'N/A' }}</td>
                    <td>{{ audit.createdAtDateTimeOffset | date: 'medium' : 'UTC' || 'N/A' }}</td>
                  </tr>
                </tbody>
              </table>
        </div>
        <div *ngIf="!isLoading && audits.length === 0">
            No audit records for the current production.
        </div>
        <mat-spinner *ngIf="isLoading" color="primary" style="margin-top: 36px;"></mat-spinner>
    </div>
</mat-dialog-content>
<mat-dialog-actions
    style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex;">
    <button mat-raised-button mat-dialog-close cdkFocusInitial>Close</button>
</mat-dialog-actions>